import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#080ed5',
        secondary: '#dceffe',
        third: '#FFFFFF',
        accent: '#AAA95A',
        error: '#b71c1c',
        text: '#000000',
      },
    },
  },
});
	